import { Injectable } from '@angular/core';
import moment from 'moment-timezone';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class UtilService {

  constructor(private authService: AuthService) {}

  public deepCopy(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  public openUrlInNewTab(urlString: string) {
    window.open(urlString, "_blank");
  }

  public capitalizeString(str: string): string {
    return str.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  public generateUuid(): string {
    return 'SPOTFExx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line: no-bitwise
      const r = Math.random() * 16 | 0;
      // tslint:disable-next-line: no-bitwise
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  public prependZero(num: number|string): string {
    return Number(num) < 10 ? '0' + num : String(num);
  }

  public convertToDateTimeString(date: any, time: string): string {
    const momentObj = moment(date.format('DD/MM/YYYY') + ' ' + time, "DD/MM/YYYY h:mm A");
    return this.convertMomentToDateTimeString(momentObj);
  }

  public conver24HourTimeToHumanTime(timeStr) {
    const momentObj = moment(timeStr, 'HH:mm');
    return momentObj.format('hh:mm A');
  }

  public converDateTimeToDisplayTime(dateTime: string) {
    const timeStr = dateTime.split(' ')[1];
    const timeArr = timeStr.split('/');
    const hour = Number(timeArr[0]);
    const minutes = timeArr[1];
    const period = hour > 11 ? 'PM' : 'AM';
    const formattedHour = this.prependZero(hour === 0 ? 12 : (hour > 12 ? hour - 12 : hour));
    return formattedHour + ':' + minutes + ' ' + period;
  }

  public getMomentDateWithOffset() {
    return moment(this.authService.serverTime, 'DD/MM/YYYY HH/mm/ss');
  }

  public getMoment(date?: any, format?: any): any {
    if (!date) {
      // get moment date with offset
      return this.getMomentDateWithOffset();
    } else {
      const currentFormat = format || 'DD/MM/YYYY HH/mm/ss';
      return moment(date, currentFormat);
    }
  }

  public convertMomentToDateTimeString(date: any) {
     return moment(date).format('DD/MM/YYYY HH/mm/ss');
  }

  public convertMomentToDateTimeStringWithoutSec(date: any) {
    return moment(date).format('DD/MM/YYYY HH/mm');
 }

  public convertMomentToDateTimeStringinDotFormat(date: Date) {
    return moment(date).format('DD/MM/YYYY HH:mm:ss');
 }

  public convertMomentToDateString(date: Date | moment.Moment | moment.Moment[]) {
    if (!date) return '';

    if (Array.isArray(date)) // when receiving [moment]
        return date.map(d => moment(d).format('DD/MM/YYYY')).join(', ');
     else // when receiving {moment}
        return moment(date).format('DD/MM/YYYY');
    
}

  public findTimeDiffInMinutes(date: any) {
    const now = this.getMoment();
    const dateFormatted = typeof(date) === 'string' ? this.getMoment(date) : date;
    const duration = moment.duration(dateFormatted.diff(now));
    const durationInMinutes = duration.asMinutes();

    return durationInMinutes;
  }

  public checkIfDateTimeBetween(startTime: any, endTime: any) {
    if (!startTime || !endTime) {
      return true;
    }
    const now = this.getMoment();
    const startDate = this.getMoment(startTime, 'HH:mm');
    const endDate = this.getMoment(endTime, 'HH:mm');

    if (now.isBetween(endDate, startDate)) {
      return true;
    }
    return true;
  }

  public convert12HrTimeToMilitaryTime(timeString: string) {
    const momentObj = moment(timeString, "h:mm A");
    return Number(momentObj.format('HHmm'));
  }

  public appendStringWithCommaSeperator(str, addendum) {
    if (addendum) {
      if (str) {
        str += ', ';
      }
      str += addendum;
    }
    return str;
  }

  convertMinsToHours(mins: number) {
    if (mins > 60) {
      return Math.floor(mins / 60) + (Math.floor(mins / 60) > 1 ? ' hours ' : ' hour ') +
        (mins % 60) + ' mins';
    } else {
      return mins + ' mins';
    }
  }

  getNextPossibleValidDate(date, disabledDays){
    const currentDay = date;
    if (disabledDays.length === 0 || disabledDays.length === 7) {
      return currentDay;
    }
    do{
      if (disabledDays.includes('w' + currentDay.getDay())) {
        currentDay.setDate(currentDay.getDate() + 1);
      }
      else {
        return currentDay;
      }
    }while (true);
  }

}
